import cookie from "./useCookie";

const getToken = cookie.getCookie('ID_USER_ACCOUNT')

export const accessToken = getToken ? `Bearer ${getToken}` : false;